import { HttpClient } from '@angular/common/http';
import { isDevMode } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ReportType } from '@app/domain/model/report-type';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var PurchaseReportCreationEditingService = /** @class */ (function () {
    function PurchaseReportCreationEditingService(http) {
        this.http = http;
    }
    PurchaseReportCreationEditingService.prototype.addPurchaseReport = function (report, dealerId) {
        // Convert the purchase report into JSON representation, ...
        var requestBody = JSON.stringify(Object.assign({}, {
            amendments: report.amendments,
            boatNotUsed: report.boatNotUsed,
            notifyFisher: report.notifyFisher,
            purchases: report.purchases.map(function (purchase) { return Object.assign({}, purchase); }),
            reportDate: report.reportDate,
            reportType: ReportType[report.reportType],
            remarks: report.remarks,
            sellerId: report.sellerId,
            vessel: report.vessel
        }));
        // ... and send it to the back-end.
        return this.http
            .post('dealers/' + (dealerId ? dealerId : 'mine') + '/reports/', requestBody, { headers: { 'Content-Type': 'application/json' } })
            .pipe(catchError(this.handleError));
    };
    PurchaseReportCreationEditingService.prototype.editPurchaseReport = function (reportId, report) {
        // Convert the purchase report into JSON representation, ...
        var requestBody = JSON.stringify(Object.assign({}, {
            amendments: report.amendments,
            boatNotUsed: report.boatNotUsed,
            notifyFisher: report.notifyFisher,
            purchases: report.purchases.map(function (purchase) { return Object.assign({}, purchase); }),
            reportDate: report.reportDate,
            reportType: ReportType[report.reportType],
            remarks: report.remarks,
            sellerId: report.sellerId,
            vessel: report.vessel
        }));
        // ... and send it to the back-end.
        return this.http
            .put("reports/" + reportId + "/", requestBody, { headers: { 'Content-Type': 'application/json' } })
            .pipe(catchError(this.handleError));
    };
    PurchaseReportCreationEditingService.prototype.handleError = function (error) {
        if (isDevMode()) {
            console.error('Add purchase report problem: ', error);
        }
        return throwError(error);
    };
    PurchaseReportCreationEditingService.ngInjectableDef = i0.defineInjectable({ factory: function PurchaseReportCreationEditingService_Factory() { return new PurchaseReportCreationEditingService(i0.inject(i1.HttpClient)); }, token: PurchaseReportCreationEditingService, providedIn: "root" });
    return PurchaseReportCreationEditingService;
}());
export { PurchaseReportCreationEditingService };
